<mat-toolbar class="secondary-toolbar mat-elevation-z1">
</mat-toolbar>

<section class="main-content">
  <app-user-list #userList (stateChange)="onStateChange($event)" ></app-user-list>
</section>
